import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React, { useState } from 'react';

import { CardDiagnosticosActivos } from './DiagnosticosHCE/CardDiagnosticosActivos';
import { CardAntecedentesPersonales } from './DiagnosticosHCE/CardAntecedentesPersonales';
import { CardAntecedentesFamiliares } from './DiagnosticosHCE/CardAntecedentesFamiliares';
import { CardProblemasResueltos } from './DiagnosticosHCE/CardProblemasResueltos';
import { CardProcedimientos } from './DiagnosticosHCE/CardProcedimientos';
import { CardPasadasError } from './DiagnosticosHCE/CardPasadasError';

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      marginTop: 25,
    },
    fixedHeight: {
      height: 350,
    },
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      padding: theme.spacing(0, 0, 0),
      marginTop: '50px',
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    footer: {
      padding: theme.spacing(3),
      marginTop: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
  };
});

export const TabDiagnosticos = (props) => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const { hce, estadosProblemas, problemas, disabled } = props;
  const [mostrarError, setMostrarError] = useState(false);

  const handleChange = (event) => {
    setMostrarError(event.target.checked); // Actualizar el estado cuando cambie el checkbox
  };

  console.log(hce)

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper}>
            <CardDiagnosticosActivos
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper}>
            <CardProblemasResueltos
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4} lg={4}>
          <Paper className={fixedHeightPaper}>
            <CardAntecedentesPersonales
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4} lg={4}>
          <Paper className={fixedHeightPaper}>
            <CardAntecedentesFamiliares
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={4} lg={4}>
          <Paper className={fixedHeightPaper}>
            <CardProcedimientos
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <FormControlLabel
            control={
              <Checkbox checked={mostrarError} onChange={handleChange} />
            }
            label={
              <Typography
                component="div"
                variant="h6"
                color="primary"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                Mostrar pasadas a error
              </Typography>
            }
          />
          {mostrarError && (
            <Paper className={fixedHeightPaper}>
              <CardPasadasError
                problemasAfiliiado={problemas}
                estadosProblemas={estadosProblemas}
                hce={hce}
                disabled={true}
              />
            </Paper>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
